<script lang="ts" setup>
import type { GoalPosition } from './PitchPositionIndicator/types'

type Props = {
  position: GoalPosition
  x: string | number
  y: string | number
  isSelected: boolean
}

const props = defineProps<Props>()

const emit = defineEmits<{
  click: [position: GoalPosition]
}>()

function handleClick(): void {
  emit('click', props.position)
}
</script>

<template>
  <rect
    class="cursor-pointer fill-[rgba(196,209,222,1)]"
    :class="{ 'fill-[rgba(0,147,216,1)]!': isSelected }"
    :x
    :y
    width="49.0339"
    height="32"
    rx="7.5"
    stroke="rgba(156,178,201,1)"
    stroke-dasharray="4 4"
    @click="handleClick"
  />
</template>
